import { useState } from "react";
import dispatchService from "services/dispatch.service";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import MDButton from 'components/MDButton';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export default function ApproveDispatchDialog({
    open,
    handleClose,
    dispatchId,
    id
}) {
    const [dispatch, setDispatch] = useState({});
    const [selOrg, setSelOrg] = useState(null);
    const [errors, setErrors] = useState({});

    // Handles individual field updates to the new order's state
    const changeHandler = (e) => {
        const { name, value } = e.target;
        setDispatch({
            ...dispatch,
            [name]: value
        });
    }

    // Handles batch updates to the new order's state
    const batchChangeHandler = (updates) => {
        setDispatch({
            ...dispatch,
            ...updates
        })
    }

    // Handles cancelling the create order process
    const handleCancel = () => {
        setDispatch({});
        setSelOrg(null);
        setErrors({});
        handleClose();
    }

    // Handles the submission of the create order form
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (!dispatch.estimated_delivery_date) {
                setErrors({ estimated_delivery_date: "Estimated delivery date is required." });
                return;
            }

            const payload = {
                data: {
                    attributes: {
                        status: "Approved",
                        deliveryDate: dispatch.estimated_delivery_date,
                    }
                }
            }

            await dispatchService.updateDispatchStatus(dispatchId, payload);

            handleClose({ reload: true });

        } catch (error) {
            console.error("Error creating order: ", error);
        }
    }

    return (
        <Dialog open={open} onClose={handleCancel}>

            {/* Dialog Title and Context */}
            <DialogTitle> Approve Dispatch Request</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please input an estimated delivery date to approve the dispatch request.
                </DialogContentText>

                {/* Form for Creating the Order */}
                <form onSubmit={handleSubmit} id="subscription-form">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Estimated Delivery Date"
                                    value={dispatch.estimated_delivery_date || null}
                                    onChange={(newValue) => {
                                        batchChangeHandler({ estimated_delivery_date: newValue });
                                    }}
                                    renderInput={(params) => <TextField {...params} fullWidth margin="normal" />}
                                    slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                error: errors.estimated_delivery_date ? true : false,
                                                helperText: errors.estimated_delivery_date || "",
                                            }
                                        }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>


                </form>

            </DialogContent>

            {/* Dialog action buttons */}
            <DialogActions>
                <MDButton
                    color="info"
                    variant="gradient"
                    size="small"
                    onClick={handleCancel}>
                    Cancel
                </MDButton>
                <MDButton
                    color="success"
                    variant="gradient"
                    size="small"
                    type="submit"
                    form="subscription-form">
                    Approve
                </MDButton>
            </DialogActions>

        </Dialog >
    );
}
